import * as actionTypes from './actionTypes';

export const setSelectedStart = () => {
    return {
        type: actionTypes.SET_SELECTED_START
    }
}

export const setSiteSelected = (selectedSite) => {
    return {
        type: actionTypes.SET_SITE_SELECTED,
        site: selectedSite
    }
}

export const setSelectedSuccess = (selectedSite) => {
    return {
        type: actionTypes.SET_SELECTED_SUCCESS,
        site: selectedSite
    }
}

export const setSelectedFail = (error) => {
    return {
        type: actionTypes.SET_SELECTED_FAIL,
        error: error
    }
}

export const getSiteDataStart = () => {
    return {
        type: actionTypes.GET_SITE_DATA_START
    }
}

export const getSiteData = (siteId) => {
    return {
        type: actionTypes.GET_SITE_DATA,
        siteId: siteId
    }
}

export const getSiteDataSuccess = (data) => {
    return {
        type: actionTypes.GET_SITE_DATA_SUCCESS,
        data: data
    }
}

export const getSiteDataFail = (error) => {
    return {
        type: actionTypes.GET_SITE_DATA_FAIL,
        error: error
    }
}

export const getOOSUnitsStart = () => {
    return {
        type: actionTypes.GET_OOS_UNITS_START
    }
}

export const getOOSUnits = (lob, siteId, units, unitIndex) => {
    return {
        type: actionTypes.GET_OOS_UNITS,
        lob: lob,
        siteId: siteId,
        units: units,
        unitIndex: unitIndex
    }
}

export const getOOSUnitsSuccess = (units) => {
    return {
        type: actionTypes.GET_OOS_UNITS_SUCCESS,
        units: units
    }
}

export const getOOSUnitsFail = (error) => {
    return {
        type: actionTypes.GET_OOS_UNITS_FAIL,
        error: error
    }
}